import { ComponentPropsWithRef, forwardRef } from 'react';
import { Box as MUIBox, BoxProps as MUIBoxProps } from '@mui/material';

export type BoxProps = ComponentPropsWithRef<typeof Box>;

export const Box = forwardRef<HTMLDivElement, MUIBoxProps>(
  function Box(props, ref) {
    return <MUIBox ref={ref} {...props} />;
  },
);
